import { useEffect } from "react";

import SEO from "seo/SEO";
import { SyllabusPage } from "templates";
import { scrollToTop } from "utils/utilities";

const Syllabus = () => {
  useEffect(() => {
    scrollToTop(window)
  }, [])

  return (
    <>
      <SEO
        title="Download Syllabus | Vasudev College Of Law, Haldwani"
        description="Download Syllabus of Vasudev College Of Law, Haldwani"
        keywords="Download Syllabus Vasudev College Of Law, Haldwani, SDownload Syllabus Vasudev College Of Law"        
      />   
      <SyllabusPage/>
    </>
  )
}

export default Syllabus;